import { defineStore } from 'pinia'
import {ref} from "vue";

export const useNotificationStore = defineStore('notifications', () => {

  const notifications = ref([]);

  const pushNotification = ({text, duration, type}) => {
    const notification = {text, duration, type, id: Math.random().toString(16).slice(2)};
    notifications.value.push(notification);
    if(duration > 0) {
      setTimeout(() => removeNotification(notification), (duration * 1000) + 5)
    }
    return notification;
  }

  const showMessage = (text, duration = 10) => {
    return pushNotification({text, duration, type: 'default'})
  }

  const showSuccess = (text, duration = 10) => {
    return pushNotification({text, duration, type: 'success'})
  }

  const showError = (text, duration = 10) => {
    return pushNotification({text, duration, type: 'error'})
  }

  const showLoader = (text) => {
    return pushNotification({text, duration: 0, type: 'loader'})
  }

  const removeNotification = (notification) => {
    notifications.value = notifications.value
      .filter((filterNotification) => filterNotification.id !== notification.id)
  }

  return { notifications, showMessage, showSuccess, showError, showLoader, removeNotification };
});
